import React, { useState } from 'react'
import Button from '../../UiKitComponents/Button'
import Countdown from 'react-countdown'
import styles from './countDown.module.scss'
import { useTranslation } from 'react-i18next'

const CountDown = ({
  handleResendCode,
  date,
  setDate,
  mlSeconds,
  resendStatus,
  buttonText,
}) => {
  const [resendIsAvailable, setResendIsAvailable] = useState(resendStatus)
  const { t } = useTranslation()

  const renderer = ({ minutes, seconds }) => {
    return (
      <p>
        {' '}
        {t('Sie können einen neuen Code anfordern in')}{' '}
        <span>
          {minutes}:{('' + seconds).length === 2 ? seconds : '0' + seconds}
        </span>
      </p>
    )
  }
  return (
    <div className={styles.countDown}>
      {resendIsAvailable ? (
        <Button
          text
          onClick={() => {
            handleResendCode()
            setResendIsAvailable(false)
            setDate(Date.now() + mlSeconds)
          }}
        >
          {'Bestätigungsmail erneut senden'}
        </Button>
      ) : (
        <Countdown
          date={date}
          renderer={renderer}
          onComplete={() => setResendIsAvailable(true)}
        />
      )}
    </div>
  )
}

export default CountDown
